module.exports = __webpack_public_path__ + "static/media/doubleQuoteBack.70cb5a67.svg";